webpackJsonp([14082582071903],{

/***/ 792:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"outer_wrapper":"src-components-FeaturedHalfs----FeaturedHalfs-module---outer_wrapper---1l-4L","list_news_grid":"src-components-FeaturedHalfs----FeaturedHalfs-module---list_news_grid---1kbhv","list_news_grid__item":"src-components-FeaturedHalfs----FeaturedHalfs-module---list_news_grid__item---25sYc","listen_news_grid__item_inner":"src-components-FeaturedHalfs----FeaturedHalfs-module---listen_news_grid__item_inner---33ID8","list_news_grid__category":"src-components-FeaturedHalfs----FeaturedHalfs-module---list_news_grid__category---13uFq","list_news_grid__excerpt":"src-components-FeaturedHalfs----FeaturedHalfs-module---list_news_grid__excerpt---2-oJU","author":"src-components-FeaturedHalfs----FeaturedHalfs-module---author---1SBrP","date":"src-components-FeaturedHalfs----FeaturedHalfs-module---date---PBIfP","divider":"src-components-FeaturedHalfs----FeaturedHalfs-module---divider---JPhSh"};

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FeaturedHalfsModule = __webpack_require__(792);
	
	var _FeaturedHalfsModule2 = _interopRequireDefault(_FeaturedHalfsModule);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeaturedHalfs = function FeaturedHalfs(_ref) {
		var articles = _ref.articles,
		    style = _ref.style;
	
		var items = articles.map(function (_ref2, idx) {
			var node = _ref2.node;
	
			return _react2.default.createElement(
				"li",
				{
					key: idx,
					className: _FeaturedHalfsModule2.default.list_news_grid__item + " mb-4",
					style: {
						backgroundImage: "url(" + node.featuredImage.sizes.src + ")"
	
					}
				},
				_react2.default.createElement(
					"div",
					{ className: "row " },
					_react2.default.createElement(
						"div",
						{
							className: "col-12 col-lg-8 " + _FeaturedHalfsModule2.default.listen_news_grid__item_inner
						},
						_react2.default.createElement(
							"span",
							{ className: _FeaturedHalfsModule2.default.list_news_grid__category },
							node.researchArea.title
						),
						" ",
						_react2.default.createElement(
							"h5",
							null,
							_react2.default.createElement(
								_gatsbyLink2.default,
								{
									to: "/" + node.node_locale + "/research/story/" + node.slug + "/",
									className: "list_news_grid__link"
								},
								node.title
							)
						),
						_react2.default.createElement(
							"span",
							{ className: _FeaturedHalfsModule2.default.list_news_grid__excerpt },
							_react2.default.createElement(
								"p",
								null,
								node.content.childMarkdownRemark.excerpt
							)
						)
					)
				)
			);
		});
		return _react2.default.createElement(
			"div",
			{ className: _FeaturedHalfsModule2.default.outer_wrapper },
			_react2.default.createElement(
				"div",
				{ className: "container py-lg-3" },
				_react2.default.createElement(
					"div",
					{ className: "row no-gutters " },
					_react2.default.createElement(
						"div",
						{ className: "col" },
						_react2.default.createElement(
							"ul",
							{ className: _FeaturedHalfsModule2.default.list_news_grid },
							items
						)
					)
				)
			)
		);
	};
	
	exports.default = FeaturedHalfs;
	module.exports = exports["default"];

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _CallToAction = __webpack_require__(38);
	
	var _CallToAction2 = _interopRequireDefault(_CallToAction);
	
	var _Jumbotron = __webpack_require__(17);
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	var _FeaturedHalfs = __webpack_require__(652);
	
	var _FeaturedHalfs2 = _interopRequireDefault(_FeaturedHalfs);
	
	var _subNav = __webpack_require__(73);
	
	var _subNav2 = _interopRequireDefault(_subNav);
	
	var _reactScroll = __webpack_require__(48);
	
	var _aboutUsModule = __webpack_require__(130);
	
	var _aboutUsModule2 = _interopRequireDefault(_aboutUsModule);
	
	var _PageWrapper = __webpack_require__(21);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ResearchAreas from "../components/ResearchAreas";
	
	
	// TODO: Fix the dropdown navigation for spotlight/research areas. How to do it without forcing complete refresh of the page?
	
	var ResearchSpotlight = function (_React$Component) {
		_inherits(ResearchSpotlight, _React$Component);
	
		function ResearchSpotlight(props) {
			_classCallCheck(this, ResearchSpotlight);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.handleClick = function () {
				_this.setState({ featured: 2, loadMore: false });
			};
	
			_this.handleSubNavClick = function (category) {
				var locale = _this.props.data.contentfulResearchPage.node_locale;
				(0, _gatsbyLink.navigateTo)({ pathname: "/" + locale + "/research", hash: category });
			};
	
			_this.state = {
				featured: 1,
				currentCat: "spotlight",
				loadMore: false
			};
			return _this;
		}
	
		ResearchSpotlight.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
			// const { props } = this;
			// const { location } = nextProps;
	
			// if (nextState.currentCat !== this.state.currentCat) {
			// 	return true;
			// }
			// return (
			// 	location.pathname !== props.location.pathname ||
			// 	location.hash !== props.location.hash
			// );
		};
	
		ResearchSpotlight.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
			// const oldHashCategory = this.props.location.hash.slice(1);
			// const newHashCategory = nextProps.location.hash.slice(1);
	
			// if (oldHashCategory !== newHashCategory && newHashCategory.length > 0) {
			// 	this.setState({ currentCat: newHashCategory });
			// }
		};
	
		ResearchSpotlight.prototype.componentDidMount = function componentDidMount() {
			var hashCategory = this.props.location.hash.slice(1);
	
			// if (hashCategory.length > 0) {
			// 	this.setState({ currentCat: hashCategory });
			// }
	
			_reactScroll.scroller.scrollTo(hashCategory, {
				duration: 500,
				delay: 50,
				smooth: true,
				offset: -100 // Scrolls to element + 50 pixels down the page
			});
		};
	
		ResearchSpotlight.prototype.render = function render() {
			var _this2 = this;
	
			var _props = this.props,
			    transition = _props.transition,
			    data = _props.data;
	
			var researchSpotlightList = data.researchSpotlight.edges;
			var hasMorePages = data.researchSpotlight.pageInfo.hasNextPage;
			var pageSettings = data.contentfulResearchPage;
			var cta = data.cta.edges[0].node;
	
			var navList = [{
				label: "Research Spotlight",
				name: "spotlight",
				href: "research"
			}, {
				label: "Research Areas",
				name: "areas",
				href: "research-areas"
			}];
	
			return _react2.default.createElement(
				_PageWrapper2.default,
				{ locale: pageSettings.node_locale, location: this.props.location, data: data.layout.edges[0].node },
				_react2.default.createElement(
					"main",
					{ role: "main", style: transition && transition.style },
					_react2.default.createElement(_reactHelmet2.default, { title: pageSettings.pageTitle + " | Mahidol Vivax Research Unit" }),
					_react2.default.createElement(
						_reactScroll.Element,
						{ name: "spotlight", className: "element" },
						_react2.default.createElement(
							_Jumbotron2.default,
							{
								type: "jumbotron_b",
								bottomLine: true,
								className: "mb-0",
								textAlign: "text-center",
								contentAlign: "justify-content-md-center"
							},
							_react2.default.createElement(
								"h1",
								{ className: _aboutUsModule2.default.jumbo_h1 },
								pageSettings.pageTitle
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "grey_bg ", style: { position: "relative" } },
						_react2.default.createElement(
							"div",
							{
								className: "container",
								style: { transform: "translateY(-50%)" }
							},
							_react2.default.createElement(
								"div",
								{ className: "row justify-content-center" },
								_react2.default.createElement(
									"div",
									{ className: "col-12 col-lg-10" },
									_react2.default.createElement(_subNav2.default, {
										active: "spotlight",
										scroll: false,
										noHash: true,
										navList: navList,
										locale: pageSettings.node_locale,
										handleClick: this.handleSubNavClick
									})
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						null,
						_react2.default.createElement(
							"div",
							null,
							_react2.default.createElement(_FeaturedHalfs2.default, {
								articles: researchSpotlightList
	
							})
						),
						hasMorePages && _react2.default.createElement(
							"div",
							{ className: "grey_bg py-4 pb-5" },
							_react2.default.createElement(
								"div",
								{ className: "container" },
								_react2.default.createElement(
									"div",
									{ className: "row" },
									_react2.default.createElement(
										"div",
										{ className: "col-12 text-center" },
										_react2.default.createElement(
											"button",
											{
												role: "button",
												className: "button",
												onClick: function onClick() {
													return _this2.handleClick();
												}
											},
											"Load More"
										)
									)
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "p-lg-3" },
							_react2.default.createElement(_CallToAction2.default, {
								className: "my-5",
								text: cta.content.childMarkdownRemark.html,
								buttonLabel: cta.buttonLabel,
								destination: "/" + pageSettings.node_locale + cta.linkTo,
								arrow: true
							})
						)
					)
				)
			);
		};
	
		return ResearchSpotlight;
	}(_react2.default.Component);
	
	exports.default = ResearchSpotlight;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-research-template-js-120837a2b3253205a43a.js